import { selectUserProfile } from '@glass/web/modules/auth';
import selectGeoCity from '@glass/web/modules/userConfig/selectors/selectGeoCity';

import selectPaymentFormCity from '@glass/shared/modules/payments/selectors/selectPaymentFormCity';

const selectUserResumeCity = (state) =>
  selectUserProfile(state)?.city || selectPaymentFormCity(state) || selectGeoCity(state)?.names?.en;

export default selectUserResumeCity;
